import React, { useState } from "react";
import { googleMapsPlacesAPI } from "./GoogleAutoComplete";

const AutoComplete = (props) => {
  const LoadingJSX = (
    <div className="text-center">
      <span>Loading..</span>
    </div>
  );
  const noPlacesFound = (
    <div className="text-center">
      <span>No Results found.</span>
    </div>
  );

  const PlacesDropDownList = (props) => {
    const JSX = (
      <span>
        <button
          type="button"
          data-value={props.description}
          className="places-list"
          onClick={(e) => {
            updateAddress(e);
          }}
        >
          <span className="main-text" data-value={props.description}>
            {props.place.main_text}
          </span>
          <span className="secondary-text" data-value={props.description}>
            {props.place.secondary_text}
          </span>
        </button>
      </span>
    );
    return JSX;
  };
  const [placesList, setPlacesList] = useState(LoadingJSX);

  const [showPlacesList, setShowPlacesList] = useState(false);
  const [predictionsTimer, setPredictionTimer] = useState(null);

  function fetchPlacesPrediction(e) {
    clearTimeout(predictionsTimer);
    setPredictionTimer(null);
    // props.changeHandler(e.target.value);
    const queryToSearch = e.target.value;
    const request = {
      input: queryToSearch,
      componentRestrictions: { country: "in" },
    };
    if (queryToSearch.length === 0 || queryToSearch.length < 3) {
      // $("#fromAutocompletewithin").html("");
      setShowPlacesList(false);
      setPlacesList(LoadingJSX);
      return;
    }
    setShowPlacesList(true);
    setPredictionTimer(
      setTimeout(function () {
        googleMapsPlacesAPI.placeAutoComplete.getPlacePredictions(
          request,
          function (predictions, status) {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              const predictionArr = predictions;
              // renderPredicationList("from", predictionArr, cityType);
              setPlacesList(
                predictionArr.map((autoCompleteListObj, index) => {
                  const place = autoCompleteListObj.structured_formatting;
                  const JSX = (
                    <PlacesDropDownList
                      key={index}
                      description={autoCompleteListObj.description}
                      place={place}
                    />
                  );
                  return JSX;
                })
              );
            } else if (status === "ZERO_RESULTS") {
              //zero records found for the location.
              setPlacesList(noPlacesFound);
            } else {
              setPlacesList(noPlacesFound);
            }
          }
        );
      }, googleMapsPlacesAPI.delay)
    );
    return;
  }
  const updateAddress = async (e) => {
    var selectedPlace = e.target.dataset;
    props.changeHandler(selectedPlace.value);
    // const getGeocode = new Promise((resolve, reject) => {
    //   if (selectedPlace.value) {
    //     const value = selectedPlace.value;
    //     googleMapsPlacesAPI.geo.geocode(
    //       { address: value },
    //       function (res, status) {
    //         var geocode = res;
    //         // var parameter = { lat: place.lat(), lng: place.lng() };
    //         if (geocode) {
    //           return resolve(geocode);
    //         } else {
    //           return reject({ data: "Failed" });
    //         }
    //       }
    //     );
    //   }
    // });
    setPlacesList("");
    setShowPlacesList(false);
    setPredictionTimer(null);
    // const result = await getGeocode;
    // try {
    //   console.log("geocode is", result);
    // } catch (error) {
    //   console.log(error);
    // }
    // .then((result) => {
    //   console.log("geocode", result);
    //   // props.changeHandler(selectedPlace.value, result);
    //   props.updateGeoCode(result);
    // })
    // .catch((error) => {
    //   console.log(error);
    // });
   
  };
  const JSX = (
    <React.Fragment>
      <input
        type="text"
        name={props.name}
        ref={props.innerRef}
        placeholder={props.placeholder}
        className={props.className}
        onChange={(e) => {
          fetchPlacesPrediction(e);
        }}
        defaultValue={props.defaultValue}
        id={props.id}
      />
      <div id={props.AutoCompleteID} className="autocomplete-container">
        {showPlacesList && placesList}
      </div>
    </React.Fragment>
  );

  return JSX;
};

export default AutoComplete;

// function renderPredicationList(field, predicitionArr, cityType) {
//     const autoCompleteList = predicitionArr;
//     var html = "";
//     var place = "";
//     for (var i = 0; i < autoCompleteList.length; i++) {
//         place = autoCompleteList[i].structured_formatting;
//         html += `<span>
//                     <button type="button" data-value="${autoCompleteList[i].description}" data-location-type="${field}_${cityType}" className="places-list">
//                     <span className="main-text"> ${place.main_text} </span>
//                     <span className="secondary-text">${place.secondary_text}</span>
//                     </button>
//                 </span>`;
//     }

//     $("#" + field + "Autocomplete" + cityType).html(html);
// }
//   function handleFromPredicitons(text, cityType) {
//     var queryToSearch = text;
//     var request = {
//         input: queryToSearch,
//         componentRestrictions: { country: "in" },
//     };

//     var selectCityName = $("#select_city").val();
//     var cityBound;
//     for (var i = 0; i < cityListBounds.length; i++) {
//         if (cityListBounds[i].city == selectCityName) {
//             cityBound = cityListBounds[i].bounds;
//         }
//     }

//     if (cityType == "within") {
//         request = {
//             input: queryToSearch,
//             bounds: cityBound,
//             componentRestrictions: { country: "in" },
//         };
//     }
//     // if(cityType == 'between') {
//     // 	request = {
//     // 		input: queryToSearch,
//     // 		componentRestrictions: { country: "in" },
//     // 		types: ["(cities)"],
//     // 	}
//     // }
//     placeAutoComplete.getPlacePredictions(request, function (
//         predictions,
//         status
//     ) {
//         if (status === google.maps.places.PlacesServiceStatus.OK) {
//             const predictionArr = predictions;
//             renderPredicationList("from", predictionArr, cityType);
//         } else if (status == "ZERO_RESULTS") {
//             $("#fromAutocomplete" + cityType).html(
//                 "<div><span>No results. </span></div>"
//             );
//             //zero records found for the location.
//         }
//     });
// }
